import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Page, Section } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { RequestConcerningForm } from '@/components/features/request-concerning';
import { Loading } from '@/components/loading';
import { FooterNavigation } from '@/components/navigation/footer-navigation';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/applications/request-concerning/',
)({
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.request.inspectionReportsListOptions({
            electricalProjectVersionId: params.projectVersionId,
        }));
        context.queryClient.ensureQueryData(
            elektraAppQueryOptions.project.selectListsItems.selectListsItemsGetOptions({
                electricalProjectVersionId: params.projectVersionId,
                listKind: 'AdditionalTopic',
            }),
        );
    },
    component: RequestConcerningPage,
    pendingComponent: () => <Loading action="Project aan het laden" />,
});

function RequestConcerningPage() {
    const { t } = useTranslation('applications');

    const params = Route.useParams();

    return (
        <Page>
            <Section>
                <Section.Header>
                    <Section.Header.Title>{t('request-concerning.title')}</Section.Header.Title>
                </Section.Header>
                <Section.Content>
                    <RequestConcerningForm projectVersionId={params.projectVersionId} />
                </Section.Content>
                <Section.Footer>
                    <FooterNavigation />
                </Section.Footer>
            </Section>
        </Page>
    );
}
